"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("../index"));

var _contactModule = _interopRequireDefault(require("./contact.module.css"));

const ContactModal = _ref => {
  let {
    isOpen,
    showClose,
    onClose,
    shouldCloseOnOverlayClick,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_index.default, {
    isOpen: isOpen,
    showClose: showClose,
    onClose: onClose,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    closeButtonPosition: "right",
    ariaHideApp: false
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _contactModule.default.container
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: _contactModule.default.topLaser,
    xmlns: "http://www.w3.org/2000/svg",
    width: "543",
    height: "153",
    viewBox: "0 0 543 153"
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "top-form-laser-a",
    x1: "12.453%",
    x2: "87.895%",
    y1: "84.924%",
    y2: "16.33%"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0%",
    stopColor: "#1D8DBA"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "100%",
    stopColor: "#03ECAE"
  })), /*#__PURE__*/_react.default.createElement("filter", {
    id: "top-form-laser-b",
    width: "111.6%",
    height: "173.1%",
    x: "-5.8%",
    y: "-36.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "10"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    fill: "url(#top-form-laser-a)",
    transform: "translate(4 16)"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "521.165 78.973 416.054 18 2.23 100.047 370.516 49.801 415.775 71.99",
    filter: "url(#top-form-laser-b)",
    opacity: ".323",
    transform: "rotate(-4 261.698 59.023)"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    points: "521.932 67.973 416.053 17.973 2.229 100.02 370.515 49.774 416.053 67.973"
  }))), children, /*#__PURE__*/_react.default.createElement("svg", {
    className: _contactModule.default.bottomEdge,
    xmlns: "http://www.w3.org/2000/svg",
    width: "624",
    height: "66",
    viewBox: "0 0 624 66"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F6FBFA",
    d: "M-1.50102153e-13,0 L624,0 L624,53.0333555 C624,54.6902098 622.656854,56.0333555 621,56.0333555 C620.876131,56.0333555 620.75238,56.0256837 620.629459,56.0103842 L504.479385,41.5535796 L332.239491,38.8944625 L104.379582,66 L1.74140405,18.56354 C0.679723123,18.0728612 -1.53436322e-13,17.0099047 -1.54098956e-13,15.8403184 L-1.50102153e-13,0 Z"
  })), /*#__PURE__*/_react.default.createElement("svg", {
    className: _contactModule.default.bottomLaser,
    xmlns: "http://www.w3.org/2000/svg",
    width: "465",
    height: "138",
    viewBox: "0 0 465 138"
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "bottom-form-laser-a",
    x1: "12.453%",
    x2: "87.895%",
    y1: "84.924%",
    y2: "16.33%"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0%",
    stopColor: "#1D8DBA"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "100%",
    stopColor: "#03ECAE"
  })), /*#__PURE__*/_react.default.createElement("filter", {
    id: "bottom-form-laser-b",
    width: "110%",
    height: "146.1%",
    x: "-5%",
    y: "-23%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "7.5"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    fill: "url(#bottom-form-laser-a)",
    transform: "translate(6 3)"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "3.557 76.454 215.565 117.347 451.588 19.653 215.565 90.532",
    filter: "url(#bottom-form-laser-b)",
    opacity: ".5",
    transform: "rotate(-2 227.572 68.5)"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    points: "3.557 76.454 215.565 117.347 451.588 19.653 215.565 90.532",
    transform: "rotate(-5 227.572 68.5)"
  })))));
};

ContactModal.defaultProps = {
  showClose: false,
  shouldCloseOnOverlayClick: false
};
ContactModal.propTypes = {
  isOpen: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  showClose: _propTypes.default.bool,
  shouldCloseOnOverlayClick: _propTypes.default.bool,
  children: _propTypes.default.any.isRequired
};
var _default = ContactModal;
exports.default = _default;